export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  SERVICES: "/services",
  USERS: "/users",
  USER_DETAILS: "/users/:userId",
  TRANSACTIONS: "/transactions",
  INVOICES: "/invoices",
  ORDER_RIDE: "/order-ride",
  RECENT_SERVICES_HASH: "recent-services",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
